import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import ProductType from './ProductType'
import { Tag } from 'antd'
import moment from "moment"

class BatchesRows extends Component {
    _generateLevel = (level) => {
        const color = level === 3 ? 'rgb(255 45 0)' : level === 2 ? '#FFD300' : ''
        switch(level){
            case 3 :
                return <Tag className={classNames(`tag-highest`)} color={color}>highest</Tag>
            case 2 :
                return <Tag className={classNames(`tag-high`)} color={color}>high</Tag>
            default:
                return <Tag className={classNames(`tag-medium`)} color={color}>medium</Tag>
        }
    }

    render() {
        const { item, onChangeProductType, adminRole } = this.props
        const { status, created_at, product_types, lasers, partner} = item
        const { cut_time, cutter_name, started_at, finished_at, total } = Object.assign({}, lasers)
        const { name } = partner

        const color = classNames({
            'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
            'printing progress-bar-animated progress-bar-striped': status === 'printing',
            'printed': status === 'printed',
            'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
            'transferred': status === 'transferred',
            'confirmed': status === 'confirmed',
            'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
            'sewing': status === 'sewing',
            'completed': status === 'completed' || status === 'done',
        })

        return (
            <tr key={item._id}>
                <td className="nameLo">
                    <Link to={`/batches/${item._id}`} className="d-block">
                        {item.name}
                    </Link>
                    {
                        this._generateLevel(item.level_number)
                    }
                </td>
                <td>
                    {created_at ? moment(created_at).format("HH:mm DD/MM/YYYY") : ""}
                </td>
                <ProductType types={product_types} onChangeProductType={onChangeProductType} />
                <td className="Status">
                    <span className={`badge ${color} badge-pill`}>{status}</span>
                </td>
                {adminRole &&
                    <td className="text-center">{total >= 0 ? total : ''}</td>
                }
                <td className="text-center">{cut_time ? cut_time : '-'}</td>
                <td className="HumanCreate">{cutter_name}</td>
                <td className="info-partner">{name ? name : ''}</td>
                <td className="time-start">{started_at ? moment(started_at).format("HH:mm DD/MM/YYYY") : ''}</td>
                <td className="time-end">{finished_at ? moment(finished_at).format("HH:mm DD/MM/YYYY") : ''}</td>
            </tr>
        )
    }
}

BatchesRows.propTypes = {
    item: PropTypes.object.isRequired,
    onChangeProductType: PropTypes.func
}

export default BatchesRows
